import { useState, useEffect } from 'react';
import './App.css';
import AboutMe from './Component/AboutMe/AboutMe';
import Blogs from './Component/Blog/Blogs';
import Contact from './Component/Contact/Contact';
import Footer from './Component/Footer/Footer';
import Projects from './Component/Projects/Projects';
import Skills from './Component/Skills/Skills';
import Slider from './Component/SliderAndNavbar/Slider';
import firebase from "firebase/app";
import "firebase/auth";
import firebaseConfig from './firebaseConfig';
import DialogWindow from './Component/DialogWindow';
import SpinLoader from './Component/Loader';
import AOS from 'aos'
import 'aos/dist/aos.css';

if(!firebase.apps.length){
  firebase.initializeApp(firebaseConfig);
}

function App() {
  const [userInfo, setUserInfo] = useState(null)
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
      setOpen(false);
  };

  const SignOutAccount = () => firebase.auth().signOut()

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
            if(user.emailVerified){
              const information = {name: user.displayName, email: user.email, photo: user.photoURL, fId: user.uid}
              setUserInfo(information);
            }
        } else {
            setUserInfo(null)
        }
    });
    // window.AOS.init({
    //   duration: 1000
    // })
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  }, [])
  AOS.init();

  return (
    <div className="App">
      {
        !isLoading ?
        <>
          <Slider user={userInfo} SetOpen={setOpen} SignOutAccount={SignOutAccount}/>
          <Skills />
          <Projects />
          <AboutMe user={userInfo} SetOpen={setOpen}/>
          <Blogs />
          <Contact user={userInfo} handleOpen={handleClickOpen}/>
          <Footer />
          <DialogWindow IsUser={userInfo} Open={open} SetOpen={setOpen} HandleClose={handleClose}/>
        </> :
        <SpinLoader />
      }
    </div>
  );
}

export default App;
